import React, { FC, useContext, useEffect, useState } from "react";
import { Table , Checkbox} from "semantic-ui-react";
import { FieldContext } from "../../contexts/FieldsContext";
import DraggableTableRow from "./DraggableTableRow";
import { IGrid, IGridField } from "../Interfaces/TableInterface";
import OrderMetaItem from "./OrderMetaListItem";

interface IProps {
    title: string,
    subtitle: string,
    showTableCol: boolean,
    id: string
}

const OrderMetaListBox: FC<IProps> = ({title, subtitle, showTableCol, id}) => {

    const { fields, setFields, customSizing, setCustomSizing, columnTotalWidth } = useContext(FieldContext);

    const [sortItems, setSortItems] = useState<any>(fields);
    const [render, rerender] = useState(false);
    const [widthCount, setWidthCount] = useState<number>(0);

    useEffect(() => {
        calculateWidth(fields);
    }, [render, customSizing]);

    const updateList = (field: IGridField, toDelete: boolean) => {
        let updatedList = [];

        if (toDelete) {
            updatedList = fields.filter((x: IGridField) => x.propertyId !== field.propertyId);
        } else {
            updatedList = fields.map((x: IGridField) => {
                if (x.propertyId === field.propertyId) {
                   x = field
                }
                return x;
            });
        }

        //recaculate sum of all column width
        calculateWidth(updatedList);
        setFields(updatedList);
    }

    const calculateWidth = (fieldsSelected: IGridField []) => {
        //recaculate sum of all column width
        if (customSizing) {
            let totalWidth = 0;
            fieldsSelected.forEach((field: IGridField) => {
                if (field.colWidth > 0) {
                    totalWidth = field.colWidth + totalWidth;
                }
            });

            setWidthCount(totalWidth);
        }
    }

    const swapItems = (to: number, from: number) => {
         let items = fields;
        const element = items.splice(from, 1)[0];
        items.splice(to, 0, element);

        setFields(items);
        setSortItems(items);
        rerender(!render);
    }

    return (
        <div id={id}>
            <div className="header gray headerStyleGray" style={{ marginLeft: 0 , marginTop:10}}>{title}</div>
            <div className="meta" style={{ marginBottom: 10 }}>{subtitle}</div>

            <Checkbox toggle label='Custom Column Sizing' onChange={() => setCustomSizing(!customSizing)} checked={customSizing} style={{ marginRight: 10 }} />
            <div className="meta" >Combined coloumn widths must equal {columnTotalWidth}</div>

            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Name</Table.HeaderCell>
                        {showTableCol &&
                            <Table.HeaderCell>Alias</Table.HeaderCell>
                        }

                        {customSizing &&
                            <Table.HeaderCell>Column Width</Table.HeaderCell>
                        }
                        <Table.HeaderCell>Delete</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body style={{ overflowY: "auto", height: "300px" }}>
                    { 
                        fields?.map((x: IGridField, i: number) => {
                            return (
                                <DraggableTableRow key={i} index={i} action={swapItems}>
                                    <OrderMetaItem key={x.propertyId} field={x} showTableCol={showTableCol} showColWidth={customSizing } callback={updateList} />
                                </DraggableTableRow>
                            )
                        })
                    }

                    {customSizing && (
                        <>
                            <Table.Cell></Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell>
                                <span style={{ color: widthCount > columnTotalWidth ? "red": "black"}}>Total: {widthCount}</span>
                            </Table.Cell>
                            <Table.Cell></Table.Cell>
                        </>
                    )}
                   
                </Table.Body>
            </Table>
        </div>
    );
}

export default OrderMetaListBox;